import { Box, Container } from "@mui/material";
import Header from "../../components/Header";
import Hero from "./Hero";
import Features from "./Features";
import GetInTouch from "./GetInTouch";
import Footer from "./Footer";
import Projects from "./Projects";

export default function Landing() {
  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        "&:before": {
          content: '""',
          background:
            "radial-gradient(91.9% 83.1% at 100% 10%, rgba(34, 34, 36, .58) 0%, rgba(8, 8, 8, 0) 100%)",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: -1,
          transform: "perspective(1200px)",
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Box sx={{ px: 2, py: { xs: 4, md: 8 } }}>
          <Header />
          <Box sx={{ px: 2, py: { xs: 7, md: "0" } }}>
            <Hero />
          </Box>
        </Box>
        <Projects />
        <Features />
        <GetInTouch />
        <Footer />
      </Container>
    </Box>
  );
}
